<template>
  <div class="flex max-w-sm flex-col rounded border-4 border-[#e7e8f0]">
    <Search v-model="search" />
    <div
      v-if="filteredList.length > 0"
      class="flex max-h-[300px] flex-col overflow-y-auto border-t-4 border-[#e7e8f0] py-1"
    >
      <Checkbox
        :value="isAllSelected"
        label="Select all"
        class="text-sm font-semibold text-grey-900"
        @input="selectAllToggle"
      />
      <Checkbox
        v-for="item in filteredList"
        :key="item.id"
        :data="{ id: item.id }"
        :value="item.selected"
        :label="item.name"
        class="text-sm font-semibold text-grey-900"
        @change="changeSelected"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import Search from '~/components/filters/Search.vue'
import Checkbox from '~/components/filters/Checkbox.vue'

type TFilterItem = {
  id: number
  name: string
  selected: boolean
}

const props = defineProps<{
  value: TFilterItem[]
}>()

const emit = defineEmits<{
  (event: 'input', value: TFilterItem[]): void
}>()

const search = ref('')

const list = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
})

const filteredList = computed(() => {
  const searchValue = search.value.toLowerCase()
  return list.value.filter((item) =>
    item.name.toLowerCase().startsWith(searchValue),
  )
})

const isAllSelected = computed(() =>
  filteredList.value.every((item) => item.selected),
)

function selectAllToggle() {
  const selected = filteredList.value.every((item) => item.selected)
  list.value = list.value.map((item) => ({ ...item, selected: !selected }))
}

function changeSelected({ id }: { id: number }) {
  const index = list.value.findIndex((item) => item.id === id)
  if (index === -1) return
  list.value.splice(index, 1, {
    ...list.value[index],
    selected: !list.value[index].selected,
  })
}
</script>
